export const bindModalClose = () => {
  $('#modal_order_curtain_confirm .popup__actions .btn-close').click((e) => {
    e.preventDefault()
    e.stopPropagation()
    $.magnificPopup.close()
  })
}
